export enum Routes {
    MAIN = '/',
    CITY_RESULT = '/municipality/:slug',
    HOME_RESULT = '/municipality/:slug/:home_id',
    PROFILE = '/profile',
    OTHER_USER = '/user',
    FRACTIONALIZATION = '/fractionalize',
    GOOGLE_REDIRECT = '/google-redirect',
    NOT_FOUND = '*',
}
